import src from "IMAGE";
export default { src, width: 590, height: 361, blurWidth: 0, blurHeight: 0};
